import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setProfile } from "../../../actions/profile";
import { getOwnProfile } from "../../../api/profile/profile";
import { getNSTBalanceApi, getNUCBalanceApi } from "../../../api/wallet/wallet";
import { fetchUserProfileImage, isAuthRoute } from "../../../utils/utils";
import { setNUCBalance, setNSTBalance } from "../../../actions/wallet";
import { setToggle, setThemeToggle } from "../../../actions/settings";
import { getToggleStatus } from "../../../api/toggle/toggle";
import NotificationDropDown from "../../Notification/NotificationDropDown/NotificationDropDown";
import $ from "jquery";
import { CSSTransition } from "react-transition-group";
import "./Header.css";

const Header = (props) => {
  const [showHeader, setShowHeader] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [isConnected, setIsConnected] = useState(true);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showMobileProfileDropdown, setShowMobileProfileDropdown] = useState(false);
  const currentUser = useSelector(state => state?.Profile?.profile?.user_name)
  useEffect(() => {
    if (localStorage.getItem("theme") === "dark") {
      $("body").toggleClass("DarkMode");
      $(".dropdown-menu").addClass("dropdown-menu-dark");
      $(".modal").addClass("DarkModal");
    }

    function changeStatus() {
     
      setIsConnected(navigator.onLine);
    }

    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  // useEffect(() => {
  //   if (props.isLoggedIn && props.profile.user_name) {
  //     getToggleStatus(
  //       props.profile.user_name,
  //       props.profile.country,
  //       "toggle_create_nft"
  //     )
  //       .then(({ data: { calculated_toggle } }) => {
  //         props.setToggle({
  //           key: "toggle_create_nft",
  //           value:
  //             props.profile.user_name === "hussfarajnft" ||
  //             props.profile.user_name === "hussfaraj"
  //               ? 1
  //               : calculated_toggle,
  //         });
  //       })
  //       .catch((e) => {
  //         props.setToggle({ key: "toggle_create_nft", value: 1 });
  //       });
  //     getToggleStatus(
  //       props.profile.user_name,
  //       props.profile.country,
  //       "toggle_kyc"
  //     )
  //       .then(({ data: { calculated_toggle } }) => {
  //         props.setToggle({ key: "toggle_kyc", value: calculated_toggle });
  //       })
  //       .catch((e) => {
  //         props.setToggle({ key: "toggle_kyc", value: 0 });
  //       });
  //   }
  // }, [props.isLoggedIn, props.profile.user_name]);

  useEffect(async () => {
    setShowHeader(!isAuthRoute(window.location.pathname));
    try {
      if (props.isLoggedIn) {
        if (!props.profile.user_name) {
          const { data } = await getOwnProfile(props.token);
         
          props.setProfile(data.data);
        }

        getNUCBalanceApi(props.token)
          .then(({ data }) => {
            props.setNUCBalance(data.data.balance);
          })
          .catch((e) => { });

        // getNSTBalanceApi(props.token)
        //   .then(({ data: { balance } }) => {
        //     props.setNSTBalance(balance);
        //   })
        //  .catch((e) => {});
      }
    } catch (e) { }
  }, [window.location.pathname]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showProfileDropdown && !event.target.closest('.profile-dropdown-wrapper')) {
        setShowProfileDropdown(false);
      }
    };

    if (showProfileDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showProfileDropdown]);

  if (!showHeader) return null;

  const {
    location: { pathname },
  } = props;

  const { user_name, display_name, profile_image } = props.profile;

  const onChangeSearchText = (e) => {
    e.preventDefault();

    setSearchText(e.target.value);
  };


  return (
    <header>
      <nav className="navbar navbar-expand-xl">
        <div className="container-fluid justify-content-start">
          <Link className="navbar-brand me-2 order-1 order-xl-1" to="/">
            <img className={"img-fluid"} src="/images/logo.png" alt="Logo" />
          </Link>
          <button
            className={
              "btn btn-danger pt-2 pb-2 px-3 text-uppercase d-xl-none me-auto order-2"
            }
          >
            Beta v4
          </button>
          <button
            onClick={() => {
              $("body").toggleClass("DarkMode");
              if ($("body").hasClass("DarkMode")) {
                $(".dropdown-menu").addClass("dropdown-menu-dark");
                $(".modal").addClass("DarkModal");
                props.setThemeToggle("dark");
              } else {
                $(".dropdown-menu").removeClass("dropdown-menu-dark");
                $(".modal").removeClass("DarkModal");
                props.setThemeToggle("light");
              }
            }}
            type="button"
            className="p-0 bg-transparent ChangeTheme rounded-circle me-3 order-3"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              width="24"
              height="24"
              xlmns="http://www.w3.org/2000/svg"
              className="Moon"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.75788 17.4844C5.07158 16.7559 6.12135 15.7797 7.1112 15.928C7.42793 15.9754 7.75214 16 8.08209 16C11.6719 16 14.5821 13.0899 14.5821 9.5C14.5821 8.42871 14.3302 7.41794 13.8791 6.52697C13.4263 5.63282 14.0229 4.31312 14.9328 4.73338C17.6775 6.00109 19.5821 8.77812 19.5821 12C19.5821 16.4183 16.0004 20 11.5821 20C9.28652 20 7.21678 19.0331 5.75788 17.4844Z"
                fill="#1BD3ED"
              ></path>
            </svg>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              width="24"
              height="24"
              xlmns="http://www.w3.org/2000/svg"
              className="Sun"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.25 4.75C11.25 4.33579 11.5858 4 12 4C12.4142 4 12.75 4.33579 12.75 4.75V6.25C12.75 6.66421 12.4142 7 12 7C11.5858 7 11.25 6.66421 11.25 6.25V4.75ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM12 17C11.5858 17 11.25 17.3358 11.25 17.75V19.25C11.25 19.6642 11.5858 20 12 20C12.4142 20 12.75 19.6642 12.75 19.25V17.75C12.75 17.3358 12.4142 17 12 17ZM19.25 11.25C19.6642 11.25 20 11.5858 20 12C20 12.4142 19.6642 12.75 19.25 12.75H17.75C17.3358 12.75 17 12.4142 17 12C17 11.5858 17.3358 11.25 17.75 11.25H19.25ZM7 12C7 11.5858 6.66421 11.25 6.25 11.25H4.75C4.33579 11.25 4 11.5858 4 12C4 12.4142 4.33579 12.75 4.75 12.75H6.25C6.66421 12.75 7 12.4142 7 12ZM16.5962 6.34314C16.8891 6.05024 17.364 6.05024 17.6569 6.34314C17.9497 6.63603 17.9497 7.1109 17.6569 7.4038L16.5962 8.46446C16.3033 8.75735 15.8284 8.75735 15.5355 8.46446C15.2426 8.17156 15.2426 7.69669 15.5355 7.4038L16.5962 6.34314ZM8.46447 15.5355C8.17158 15.2426 7.69671 15.2426 7.40381 15.5355L6.34315 16.5962C6.05026 16.8891 6.05026 17.3639 6.34315 17.6568C6.63605 17.9497 7.11092 17.9497 7.40381 17.6568L8.46447 16.5962C8.75737 16.3033 8.75737 15.8284 8.46447 15.5355ZM17.6569 16.5962C17.9498 16.8891 17.9498 17.364 17.6569 17.6569C17.364 17.9497 16.8891 17.9497 16.5962 17.6569L15.5355 16.5962C15.2427 16.3033 15.2427 15.8284 15.5355 15.5355C15.8284 15.2426 16.3033 15.2426 16.5962 15.5355L17.6569 16.5962ZM8.46448 8.46447C8.75738 8.17158 8.75738 7.69671 8.46448 7.40381L7.40382 6.34315C7.11093 6.05026 6.63605 6.05026 6.34316 6.34315C6.05027 6.63605 6.05027 7.11092 6.34316 7.40381L7.40382 8.46447C7.69671 8.75737 8.17159 8.75737 8.46448 8.46447Z"
                fill="#1BD3ED"
              ></path>
            </svg>
          </button>
          {props.isLoggedIn && (
            <div className="d-xl-flex align-items-center order-3">
              <div className="d-none d-xl-flex">
                <div className="profile-dropdown-wrapper">
                  <button
                    className="profile-button"
                    onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                    aria-expanded={showProfileDropdown}
                    aria-haspopup="true"
                  >
                    <div className="profile-button-content">
                      <div className="profile-avatar-wrapper">
                        <img
                          className="profile-avatar"
                          src={fetchUserProfileImage(profile_image)}
                          alt={`${display_name || user_name}'s profile`}
                        />
                        <span className="profile-avatar-status" aria-label="Online"></span>
                      </div>
                      <div className="profile-info">
                        <h6 className="profile-greeting">
                          Hi {display_name || user_name}
                        </h6>
                        <span className="profile-welcome">
                          Welcome Back
                        </span>
                      </div>
                      <div className={`profile-chevron ${showProfileDropdown ? 'open' : ''}`}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5 7.5L10 12.5L15 7.5"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </button>

                  {showProfileDropdown && (
                    <>
                      <div
                        className="dropdown-backdrop"
                        onClick={() => setShowProfileDropdown(false)}
                        aria-hidden="true"
                      ></div>
                      <div
                        className="profile-dropdown-menu"
                        role="menu"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="dropdown-header">
                          <img
                            className="dropdown-header-avatar"
                            src={fetchUserProfileImage(profile_image)}
                            alt={`${display_name || user_name}'s profile`}
                          />
                          <h5 className="dropdown-header-name">{display_name || user_name}</h5>
                          <p className="dropdown-header-username">@{user_name}</p>
                        </div>

                        <ul className="dropdown-menu-items">
                          <li className="dropdown-menu-item">
                            <Link
                              className="dropdown-menu-link"
                              to="/user/profile/edit"
                              onClick={() => setShowProfileDropdown(false)}
                              role="menuitem"
                            >
                              <div className="dropdown-menu-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                                    stroke="#7B7B7B"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                              <span>Edit Profile</span>
                            </Link>
                          </li>

                          <div className="dropdown-menu-separator"></div>

                          <li className="dropdown-menu-item">
                            <button
                              className="dropdown-menu-button logout-button"
                              onClick={() => {
                                const theme = localStorage.getItem("theme");
                                localStorage.clear();
                                localStorage.setItem("theme", theme);
                                window.location.href = "/";
                              }}
                              role="menuitem"
                            >
                              <div className="dropdown-menu-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9M16 17L21 12M21 12L16 7M21 12H9"
                                    stroke="#dc2626"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                              <span>Logout</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          <button
            className="navbar-toggler px-2 order-4 collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="navbar-collapse flex-column flex-lg-row collapse order-4 order-xl-2"
            id="navbarSupportedContent"
          >
            <div className={"d-flex align-items-center"}>
              <div className="position-relative fg--search my-2 my-xl-0 me-4">
                <Link
                  id="search-redirect"
                  to={`/search?q=${searchText}`}
                ></Link>
                <input
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      document.getElementById("search-redirect").click();
                      setSearchText("");
                    }
                  }}
                  onChange={onChangeSearchText}
                  value={searchText}
                  className="form-control rounded-pill TTNormsReg"
                  placeholder="Search nfts, users..."
                />
                <button
                  className={`p-0 border-0 bg-transparent shadow-none Fsize_18 z-index-2 ${searchText.trim().length > 0 ? 'search-pulse' : ''
                    }`}
                  onClick={() => {
                    if (searchText.trim().length > 0) {
                      document.getElementById("search-redirect").click();
                      setSearchText("");
                    }
                  }}
                  type="submit"
                >
                  <i className="fas fa-search"></i>
                </button>
                {searchText.trim().length > 0 && (
                  <div className="search-hint-tooltip show">
                    Press Enter or click icon to search
                  </div>
                )}
              </div>
              <Link
                className={`btn BtnBlack fw-bold py-2 px-3 rounded-pill d-xl-none`}
                to={"/create"}
              >
                Create
              </Link>
            </div>
            <button
              className={
                "btn btn-danger pt-2 pb-2 px-4 text-uppercase d-none d-xl-block"
              }
            >
              Beta v4
            </button>
            <ul className="navbar-nav ms-xl-auto">
              <li className="nav-item me-2 me-xl-3">
                <Link
                  className={`${pathname === "/" ? "nav-link active" : "nav-link"
                    }`}
                  aria-current="page"
                  to="/"
                >
                  Explore
                </Link>
              </li>
              {props.isLoggedIn && (
                <li className="nav-item me-2 me-xl-3">
                  <Link
                    className={`${pathname === "/profile" ? "nav-link active" : "nav-link"
                      }`}
                    to={`/profile/${currentUser}`}
                  >
                    My items
                  </Link>
                </li>
              )}
              {props.isLoggedIn && (
                <li className="nav-item me-2 me-xl-3">
                  <Link
                    className={`${pathname === "/order" ? "nav-link active" : "nav-link"
                      }`}
                    to="/order"
                  >
                    My NFT Orders
                  </Link>
                </li>
              )}
              {/* <li className="nav-item me-2 me-xl-3">
                <Link
                  className={`${
                    pathname === "/invest" ? "nav-link active" : "nav-link"
                  }`}
                  to="/invest"
                >
                  Invest
                </Link>
              </li> */}
              {!props.isLoggedIn && (
                <li className="nav-item me-2 me-xl-3">
                  <Link className="nav-link" to="/login">
                    Login
                  </Link>
                </li>
              )}
              {!props.isLoggedIn && (
                <li className="nav-item me-2 me-xl-3">
                  <Link className="nav-link" to="/signup">
                    Sign Up
                  </Link>
                </li>
              )}
              {props.isLoggedIn && (
                <li className="nav-item mobile-profile-dropdown d-xl-none position-relative">
                  <button
                    className="nav-link dropdown-toggle mobile-profile-toggle border-0 bg-transparent"
                    onClick={() => setShowMobileProfileDropdown(!showMobileProfileDropdown)}
                    aria-expanded={showMobileProfileDropdown}
                    type="button"
                  >
                    <img
                      className="mobile-profile-avatar"
                      src={fetchUserProfileImage(profile_image)}
                      alt={`${display_name || user_name}'s profile`}
                    />
                    <span className="mobile-profile-name">
                      {display_name || user_name}
                    </span>
                  </button>
                  {showMobileProfileDropdown && (
                    <>
                      <div
                        className="dropdown-backdrop"
                        onClick={() => setShowMobileProfileDropdown(false)}
                        aria-hidden="true"
                      ></div>
                      <div className="mobile-dropdown-menu show">
                        <div className="mobile-dropdown-header">
                          <img
                            className="mobile-dropdown-header-avatar"
                            src={fetchUserProfileImage(profile_image)}
                            alt={`${display_name || user_name}'s profile`}
                          />
                          <h5 className="mobile-dropdown-header-name">
                            {display_name || user_name}
                          </h5>
                          <p className="mobile-dropdown-header-username">
                            @{user_name}
                          </p>
                        </div>
                        <div className="mobile-dropdown-menu-items">
                          <Link
                            className="mobile-dropdown-item"
                            to="/user/profile/edit"
                            onClick={() => setShowMobileProfileDropdown(false)}
                          >
                            <div className="mobile-dropdown-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                                  stroke="#7B7B7B"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <span>Edit Profile</span>
                          </Link>
                          <div className="mobile-dropdown-separator"></div>
                          <button
                            className="mobile-dropdown-item mobile-logout-item"
                            onClick={() => {
                              const theme = localStorage.getItem("theme");
                              localStorage.clear();
                              localStorage.setItem("theme", theme);
                              window.location.href = "/";
                            }}
                          >
                            <div className="mobile-dropdown-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9M16 17L21 12M21 12L16 7M21 12H9"
                                  stroke="#dc2626"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <span>Logout</span>
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </li>
              )}
            </ul>
            <Link
              // onClick={() => {
              //   if (props.isLoggedIn)
              //     getToggleStatus(
              //       props.profile.user_name,
              //       props.profile.country,
              //       "toggle_create_nft"
              //     )
              //       .then(({ data: { calculated_toggle } }) => {
              //         props.setToggle({
              //           key: "toggle_create_nft",
              //           value:
              //             props.profile.user_name === "hussfarajnft" ||
              //               props.profile.user_name === "hussfaraj"
              //               ? 1
              //               : calculated_toggle,
              //         });
              //       })
              //       .catch((e) => {
              //         props.setToggle({ key: "toggle_create_nft", value: 1 });
              //       });
              // }}
              className={`btn BtnBlack py-2 px-3 rounded-pill me-3 d-none d-xl-inline-block`}
              to={"/create"}
            >
              Create
            </Link>
            <a
              className={`btn BtnBlack py-2 px-3 rounded-pill me-3 d-none d-xl-inline-block`}
              target="_blank"
              href="https://explorer.nucoin.com.au"
            >
              NFT Explorer
            </a>
          </div>
        </div>
      </nav>

      <CSSTransition
        in={!isConnected}
        timeout={200}
        classNames={"internet-error"}
        unmountOnExit
      >
        <div
          style={{
            width: "100%",
            textAlign: "center",
            padding: 3,
            backgroundColor: "red",
            color: "white",
            fontSize: 13,
            position: "absolute",
          }}
        >
          Internet connection is down!
        </div>
      </CSSTransition>
    </header>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.Auth.isLoggedIn,
  token: state.Auth.token,
  profile: state.Profile.profile,
});

export default connect(mapStateToProps, {
  setProfile,
  setNSTBalance,
  setNUCBalance,
  setToggle,
  setThemeToggle,
})(Header);
